module.exports = __webpack_public_path__ + "img/SSWS_Black_Sword.2402e4b4.png";